module.exports = __webpack_public_path__ + "media/src/assets/images/user-evidence-2a48d5a213d0b0e3f8515d350154ffdc.svg";